export default __webpack_public_path__ + "static/media/fine-dining.1aac839d.md";